import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUrunSatisAnaliz_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUrunSatisAnaliz_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  Boss_VItemSalesGrid: any[];
  Boss_VItemSalesGrid_dummy: any[];
  Boss_VItemSalesHeader1: any[];
  Boss_VItemSalesHeader1_dummy: any[];
  Boss_VItemSalesHeaderPerson: any[];
  Boss_VItemSalesHeaderPerson_dummy: any[];
  Boss_VItemSalesHeaderCollection: any[];
  Boss_VItemSalesHeaderCollection_dummy: any[];
  Boss_VItemSalesHeaderProcess: any[];
  Boss_VItemSalesHeaderProcess_dummy: any[];
  Boss_VItemSalesHeaderWarehouse: any[];
  Boss_VItemSalesHeaderWarehouse_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
}

export class UrunSatisAnaliz_ScreenBase extends React.PureComponent<
  IUrunSatisAnaliz_ScreenProps,
  any
> {
  urunsatisanaliz_999120_value_kuikaSelectBoxRef: React.RefObject<any>;
  urunsatisanaliz_525060_value_kuikaSelectBoxRef: React.RefObject<any>;
  urunsatisanaliz_38920_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "200193c9-ebb2-4f26-811e-fbddb6017e5a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 828549, PropertyName: "label", Value: "Profil" },
        { Id: 398998, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 342102, PropertyName: "value", Value: "Ürün Satış Analizi" },
        { Id: 999120, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 554173, PropertyName: "value", Value: "Toplam Satış Miktarı" },
        { Id: 263376, PropertyName: "value", Value: "adet" },
        { Id: 131904, PropertyName: "value", Value: "Plasiyer Bazında" },
        { Id: 859996, PropertyName: "value", Value: "Operasyonel Bazlı Satış" },
        { Id: 622157, PropertyName: "value", Value: "Mağaza/Depo Bazında" },
        { Id: 311977, PropertyName: "value", Value: "Toplam Satış Tutar" },
        { Id: 403097, PropertyName: "value", Value: "₺" },
        { Id: 224057, PropertyName: "value", Value: "Koleksiyon Bazlı" },
        { Id: 904302, PropertyName: "value", Value: "Top 20 Ürün" },
        {
          Id: 525060,
          PropertyName: "placeholder",
          Value: "Ürün adet/Tutar bazlı arama...",
        },
        { Id: 636739, PropertyName: "placeholder", Value: "Ürün ara..." },
        { Id: 178454, PropertyName: "label", Value: "Ara" },
        { Id: 530330, PropertyName: "label", Value: "Temizle" },
        {
          Id: 38920,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 97762, PropertyName: "title", Value: "Title" },
        { Id: 657610, PropertyName: "value", Value: "Ürün Kodu / Adı" },
        {
          Id: 733260,
          PropertyName: "value",
          Value: "[datafield:itemdescription]",
        },
        { Id: 674017, PropertyName: "value", Value: "İade Adedi" },
        { Id: 301181, PropertyName: "value", Value: "[datafield:returnqty1]" },
        { Id: 3684, PropertyName: "value", Value: "Net Satış Adedi" },
        { Id: 937904, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 981268, PropertyName: "value", Value: "Net Satış Tutarı" },
        { Id: 2826, PropertyName: "value", Value: "[datafield:loc_netamount]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.urunsatisanaliz_999120_value_kuikaSelectBoxRef = React.createRef();
    this.urunsatisanaliz_525060_value_kuikaSelectBoxRef = React.createRef();
    this.urunsatisanaliz_636739_value_kuikaTextInputRef = React.createRef();
    this.urunsatisanaliz_38920_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      Boss_VItemSalesGrid: [],
      Boss_VItemSalesHeader1: [],
      Boss_VItemSalesHeaderPerson: [],
      Boss_VItemSalesHeaderCollection: [],
      Boss_VItemSalesHeaderProcess: [],
      Boss_VItemSalesHeaderWarehouse: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_999120: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son  6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      dataSource_525060: [
        { key: "0", text: "Adet Bazında" },
        { key: "1", text: "Tutar Bazında" },
      ],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("urunsatisanaliz", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.UrunSatisAnalizPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("urunsatisanaliz", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("urunsatisanaliz", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.UrunSatisAnalizPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  UrunSatisAnalizPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      paramByAmount_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      itemDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(3, "number"),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(3, "number"),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(3, "number"),
      dateFilter_5: ReactSystemFunctions.convertToTypeByName(3, "number"),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesGrid = result?.data.boss_VItemSalesGrid;

    stateVars.Boss_VItemSalesHeader1 = result?.data.boss_VItemSalesHeader1;
    formVars.urunsatisanaliz_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty1
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty1
        : null
    );
    formVars.urunsatisanaliz_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].loc_NetAmount
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].loc_NetAmount
        : null
    );
    stateVars.Boss_VItemSalesHeaderPerson =
      result?.data.boss_VItemSalesHeaderPerson;

    stateVars.Boss_VItemSalesHeaderCollection =
      result?.data.boss_VItemSalesHeaderCollection;

    stateVars.Boss_VItemSalesHeaderProcess =
      result?.data.boss_VItemSalesHeaderProcess;

    stateVars.Boss_VItemSalesHeaderWarehouse =
      result?.data.boss_VItemSalesHeaderWarehouse;

    stateVars.GetImage = result?.data.getImage;
    formVars.urunsatisanaliz_892125_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UrunSatisAnalizPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.urunsatisanaliz_892125_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.urunsatisanaliz_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty1
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty1
        : null
    );

    stateVars.dataSource_625475 =
      stateVars.Boss_VItemSalesHeaderPerson ??
      this.state.Boss_VItemSalesHeaderPerson;

    stateVars.dataSource_741569 =
      stateVars.Boss_VItemSalesHeaderProcess ??
      this.state.Boss_VItemSalesHeaderProcess;

    stateVars.dataSource_559977 =
      stateVars.Boss_VItemSalesHeaderWarehouse ??
      this.state.Boss_VItemSalesHeaderWarehouse;
    formVars.urunsatisanaliz_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].loc_NetAmount
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_204106 =
      stateVars.Boss_VItemSalesHeaderCollection ??
      this.state.Boss_VItemSalesHeaderCollection;

    stateVars.dataSource_38920 =
      stateVars.Boss_VItemSalesGrid ?? this.state.Boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_891895_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UrunSatisAnaliz",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "163427",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_828549_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UrunSatisAnaliz",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_398998_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_999120_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      paramByAmount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_525060_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      itemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_636739_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_999120_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesGrid = result?.data.boss_VItemSalesGrid;

    stateVars.Boss_VItemSalesHeader1 = result?.data.boss_VItemSalesHeader1;
    formVars.urunsatisanaliz_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty1
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty1
        : null
    );
    formVars.urunsatisanaliz_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].loc_NetAmount
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].loc_NetAmount
        : null
    );
    stateVars.Boss_VItemSalesHeaderCollection =
      result?.data.boss_VItemSalesHeaderCollection;

    stateVars.Boss_VItemSalesHeaderPerson =
      result?.data.boss_VItemSalesHeaderPerson;

    stateVars.Boss_VItemSalesHeaderProcess =
      result?.data.boss_VItemSalesHeaderProcess;

    stateVars.Boss_VItemSalesHeaderWarehouse =
      result?.data.boss_VItemSalesHeaderWarehouse;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_999120_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_999120_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.urunsatisanaliz_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty1
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty1
        : null
    );

    stateVars.dataSource_625475 =
      stateVars.Boss_VItemSalesHeaderPerson ??
      this.state.Boss_VItemSalesHeaderPerson;

    stateVars.dataSource_741569 =
      stateVars.Boss_VItemSalesHeaderProcess ??
      this.state.Boss_VItemSalesHeaderProcess;

    stateVars.dataSource_559977 =
      stateVars.Boss_VItemSalesHeaderWarehouse ??
      this.state.Boss_VItemSalesHeaderWarehouse;
    formVars.urunsatisanaliz_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].loc_NetAmount
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_204106 =
      stateVars.Boss_VItemSalesHeaderCollection ??
      this.state.Boss_VItemSalesHeaderCollection;

    stateVars.dataSource_38920 =
      stateVars.Boss_VItemSalesGrid ?? this.state.Boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_525060_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      paramByAmount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_525060_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      itemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_636739_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_525060_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesGrid = result?.data.boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_525060_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_525060_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_38920 =
      stateVars.Boss_VItemSalesGrid ?? this.state.Boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_178454_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      paramByAmount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_525060_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      itemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_636739_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_178454_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesGrid = result?.data.boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_178454_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_178454_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_38920 =
      stateVars.Boss_VItemSalesGrid ?? this.state.Boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_530330_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      paramByAmount_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      itemDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_530330_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesGrid = result?.data.boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_530330_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_530330_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "urunsatisanaliz_525060_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      "Key"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "urunsatisanaliz_636739_value",
        "string"
      ),
      "",
      null,
      false
    );

    stateVars.dataSource_38920 =
      stateVars.Boss_VItemSalesGrid ?? this.state.Boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [163427] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.UrunSatisAnalizPageInit();
    }
  }
}
